let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f7rUV")).then(() => parcelRequire('2zQft'));